import { UIEventHandler, useEffect, useState } from "react";

import { HyperFocusCloseBtn } from "../../HyperFocus/Views/HyperFocusCloseBtn";
import { useTranslation } from "react-i18next";

import { menuItems, MenuItemID, PROFILE_MENU_ITEM, DISPLAY_MENU_ITEM } from "../utils/mySettingsMenu";
import { ProfileSection } from "./ProfileSection";
import { DisplaySection } from './DisplaySection';

export interface Props {
  show: boolean;
  currentMenu?: MenuItemID;
  handleShowModal: () => void;
}

export const MobileMySettings = ({ show, handleShowModal }: Props) => {
  const { t } = useTranslation();

  const [activeMenu, setActiveMenu] = useState<MenuItemID>(PROFILE_MENU_ITEM);

  useEffect(() => {
    if (!show) {
      // reset menu on close
      setActiveMenu(PROFILE_MENU_ITEM);
    }
  }, [show]);

  const handleMenuItemClick = (menuItem: MenuItemID) => {
    const target = document.getElementById(menuItem);
    target?.scrollIntoView({ behavior: "smooth" });
  }
  /* istanbul ignore next */
  const onScrollHandler: UIEventHandler<HTMLDivElement> = (event) => {
    const mobileSettingsBody = event.target as HTMLDialogElement;
    const items = document.getElementsByClassName("my-settings-mobile__content-body") as HTMLCollectionOf<HTMLDivElement>;
    const scrollThreshold = mobileSettingsBody.clientWidth / 3;
    const currentPosition = mobileSettingsBody.scrollLeft + scrollThreshold;
    Array.from(items).forEach((item) => {
      if (currentPosition >= item.offsetLeft) {
        setActiveMenu(item.getAttribute("id") as MenuItemID)
      }
    });
  }

  return (
    <>
      <div className="my-settings-mobile__header">
        <div className="my-settings-mobile__header-title">
          <span>{t("mySettings.title")}</span>
          <HyperFocusCloseBtn onCloseHandler={handleShowModal} />
        </div>
        <div
          className="my-settings-mobile__tabs"
        >
          {menuItems.map((item) => (
            <div
              key={item.id}
              className={`my-settings-mobile__tab ${activeMenu === item.id ? "is-active" : ""}`}
              data-testid={`my-settings-mobile-menu-item-${item.id}`}
              onClick={() => handleMenuItemClick(item.id)}
            >
              <span>{t(item.title)}</span>
            </div>
          ))}
        </div>
      </div>
      <div
        id="my-settings-mobile__body"
        className="my-settings-mobile__body"
        data-testid="my-settings-mobile-body"
        onScroll={onScrollHandler}
      >
        <div className="my-settings-mobile__content">
          <div
            id={PROFILE_MENU_ITEM}
            data-testid={PROFILE_MENU_ITEM}
            className="my-settings-mobile__content-body scrollbar-visible"
          >
            <ProfileSection />
          </div>
          <div
            id={DISPLAY_MENU_ITEM}
            data-testid={DISPLAY_MENU_ITEM}
            className="my-settings-mobile__content-body scrollbar-visible"
          >
            <DisplaySection />
          </div>
        </div>
      </div>
    </>
  );
};
